import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { CallBand } from "@/components/landing/CallBand";
import { UrgentProblems } from "@/components/landing/UrgentProblems";
import { DoorOpening } from "@/components/landing/DoorOpening";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { NightService } from "@/components/landing/NightService";
import { Coverage } from "@/components/landing/Coverage";
import { Faq } from "@/components/landing/Faq";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { MobileDock } from "@/components/landing/MobileDock";

export default function LandingPage() {
  useEffect(() => {
    const onClick = (e) => {
      const anchor = e.target.closest && e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth" });
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#0A0D12] font-body text-zinc-100 antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <CallBand
          id="services"
          title="Riconosci il tuo problema?"
          text="Non forzare i meccanismi: descrivici il guasto al telefono e verifichiamo subito la disponibilità nella tua zona."
        />
        <UrgentProblems />
        <DoorOpening />
        <HowItWorks />
        <NightService />
        <Coverage />
        <Faq />
        <Contact />
        <CallBand
          id="final"
          title="Parla subito con FIX ROMA H24"
          text="La telefonata è il modo più rapido: descrivi il problema e indica la tua zona, al resto pensiamo noi."
        />
      </main>
      <Footer />
      <MobileDock />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}
